<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
                ref="terminalAudit"
                :visible="infoIsShows"
                @close="handleClose"
                :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">处罚信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">所属机构：</span>
                        <span>{{dialogData.data.agent_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">代理人姓名：</span>
                        <span>{{dialogData.data.real_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">代理账户：</span>
                        <span>{{dialogData.data.phone}}</span>
                    </el-col>
                </el-row>
                <el-form
                        label-position="top"
                        label-width="80px"
                        :rules="rules"
                >
                    <div class="title">选择扣款账户</div>
                    <template>
                        <el-select v-model="auditForm.pid" placeholder="请选择" style="width: 80%">
                            <el-option
                                    v-for="item in infoTable"
                                    :key="item.id"
                                    :label="`等级.${item.level} | ${item.real_name} | ${item.phone} | 分润账户余额 [${item.balance_zero}] | 活动账户余额 [${item.balance_one}]`"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                    <div class="title">处罚金额<span style="color:red">[单位:元]</span></div>
                    <el-input v-model="auditForm.amount" placeholder="请输入打款金额" style="width: 130px;"></el-input>
                    <div class="title">选择打款直营商户</div>
                    <template>
                        <el-select v-model="auditForm.mid" placeholder="不进行打款" clearable>
                            <el-option
                                    v-for="item in merchantTable"
                                    :key="item.id"
                                    :label="`${item.name} | ${item.tel}`"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                    <div class="title">打款账户银行卡号</div>
                    <template>
                        <el-form-item>
                            <el-input size clearable v-model="auditForm.settle_acc_no" placeholder="请输入打款账户银行卡号"></el-input>
                        </el-form-item>
                    </template>
                    <div class="title">备注</div>
                    <tinymce v-model="auditForm.content" ref="editor" @getVal="getVal" />
                </el-form>
                <div style="margin-top:60px">
                    <el-button
                            @click="submit"
                            type="primary"
                            size="medium"
                            style="font-size:12px"
                            :loading="loading"
                    >确 定</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import tinymce from '../../components/Editor/Editor2'
export default {
    name: "FM_dealpunishinfo",
    props: {
        infoIsShows: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
    data() {
        return {
            infoTable: [], //表格
            merchantTable: [],
            auditForm: {
                amount: "", // 处罚金额
                content: '', // 处罚详情
                settle_acc_no: '', //银行卡号
                user_id:this.dialogData.data.id,
                i_id:this.dialogData.data.litigation_id,
            },
            loading: false,
            checked: true,
            activeName: '',
            rules: { // 表单验证规则
                amount: [
                    { required: true, trigger: 'blur', message:'金额不能为空'},
                    { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确额格式,可保留两位小数' },
                    {  trigger: 'blur'},
                ]
            },
        }
    },
    mounted() {
        // 查询对应用户 上级代理商/代理账户
        this.$api.post('user/all_merchant_user', {user_id:this.dialogData.data.id}, res => {
            if (res.code == 0) {
                this.merchantTable = res.data;
                //渲染结束后取消加载
                this.loading = false;
            } else {
                this.$message.error(res.msg);
                //渲染结束后取消加载
                this.loading = false;
            }
        });
        this.$api.post('user/all_superior_user', {user_id:this.dialogData.data.id}, res => {
            if (res.code == 0) {
                this.infoTable = res.data;
                //渲染结束后取消加载
                this.loading = false;
            } else {
                this.$message.error(res.msg);
                //渲染结束后取消加载
                this.loading = false;
            }
        });
    },
    methods: {
        getVal(val) {
            this.auditForm.content = val;
        },
        // 提交处罚数据
        submit() { //提交
            this.$api.post('user/penalty_deduction_add', this.auditForm, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message.success({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        handleClose(ref) {
            this.$emit('infoClose', ref);
        }
    },
    components: {
        tinymce
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
  * {
    font-size: 12px;
  }
  .labels {
    font-weight: 700;
  }
  .desc {
    border: 1px solid #d0d0d0;
    background-color: #ebeef5;
    padding: 3px;
    line-height: 20px;
    margin-top: 5px;
  }
  .title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
    .el-button--text {
      color: #303133;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .el-input__inner,
  .el-row {
    margin: 10px 0;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      margin: 10px 0;
    }
  }
}
</style>
